module.exports = __webpack_public_path__ + "img/healthcare-visits.5bbac1a0.svg";